import React, { Component, Fragment } from 'react';
import { node, bool, func } from 'prop-types';

class Accordion extends Component {
  static propTypes = {
    children: node.isRequired,
    onClick: func,
    onlyOneOpen: bool
  };

  state = {
    openAccordions: null
  }

  static getDerivedStateFromProps (nextProps, prevState) {
    if (prevState.openAccordions === null) {
      const { children } = nextProps;
      const openAccordions = {};

      for (let i = 0; i < children.length; i++) {
        openAccordions[i] = children[i].props.open;
      }

      return {
        openAccordions: openAccordions
      };
    }

    return null;
  }

  handleClick = (e, accordion) => {
    const { props: { onClick, onlyOneOpen }, state: { openAccordions } } = this;

    const isOpen = !!openAccordions[accordion];
    const state = onlyOneOpen
      ? {
          [accordion]: !isOpen
        }
      : {
          ...openAccordions,
          [accordion]: !isOpen
        }
    ;

    this.setState({
      openAccordions: state
    });

    if (onClick) { onClick(e, state); }
  }

  renderChildrenWithProps = () => {
    const { props: { children }, state: { openAccordions } } = this;

    return (
      <Fragment>
        {React.Children.map(children, (child, i) => React.cloneElement(child, {
          onClick: this.handleClick,
          open: !!openAccordions[i],
          accordionId: i
        }))}
      </Fragment>
    );
  };

  render() {
    return (
      <ul role={'tablist'} aria-multiselectable={true}>
        {this.renderChildrenWithProps()}
      </ul>
    );
  }
}

export default Accordion;



// WEBPACK FOOTER //
// ./src/uis/components/Accordion/Accordion.js